var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kit-venues" }, [
    _c("div", { staticClass: "kit-lodging-header" }, [
      _c("h4", { domProps: { innerHTML: _vm._s(_vm.block.title) } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tours-nav" },
        _vm._l(_vm.block.venues, function(item, index) {
          return _c(
            "a",
            {
              key: "nav-" + index,
              staticClass: "nav-bullet",
              class: { active: _vm.ui.currentSlide == index },
              on: {
                click: function($event) {
                  _vm.ui.currentSlide = index
                }
              }
            },
            [_c("span")]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "kit-lodging-slider-wrapper" },
      [
        _c(
          "vue-glide",
          {
            staticClass: "kit-lodging-slider",
            attrs: { options: _vm.glideOptions },
            model: {
              value: _vm.ui.currentSlide,
              callback: function($$v) {
                _vm.$set(_vm.ui, "currentSlide", $$v)
              },
              expression: "ui.currentSlide"
            }
          },
          [
            _vm._l(_vm.block.venues, function(venue, v) {
              return _c("vue-glide-slide", { key: "g-" + v }, [
                _c(
                  "div",
                  { staticClass: "virtual-tour-wrapper" },
                  [
                    _c("VirtualTour", {
                      attrs: { place: venue.item, "place-index": v }
                    })
                  ],
                  1
                )
              ])
            }),
            _vm._v(" "),
            _c("template", { slot: "control" }, [
              _c(
                "button",
                {
                  staticClass: "nav-prev arrow-nav",
                  attrs: { "data-glide-dir": "<" }
                },
                [
                  _c("svg", { staticClass: "circle-border" }, [
                    _c("circle", { attrs: { cx: "50%", cy: "50%", r: "46%" } })
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-angle-left" })
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "nav-next arrow-nav",
                  attrs: { "data-glide-dir": ">" }
                },
                [
                  _c("svg", { staticClass: "circle-border" }, [
                    _c("circle", { attrs: { cx: "50%", cy: "50%", r: "46%" } })
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-angle-right" })
                ]
              )
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "kit-lodging-bottom-link" }, [
      _c(
        "a",
        { staticClass: "bottom-link", attrs: { href: "/places-to-stay" } },
        [
          _vm._v("\n        View all lodging "),
          _c("i", { staticClass: "fas fa-chevron-right" })
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/KitBlocks/KitLodging.vue?vue&type=template&id=9ca25d52&
// module id = 538
// module chunks = 0